<div class="container" style="padding-top: 10px;" *ngIf="showDiv">
    <div class="d-flex">
        <div class="col-2" style="margin-left:-10px">
            <img src="assets/img/locationIcon.svg" alt="">
        </div>
        <div class="col-8" style="margin-left:-10px">
            {{location}}
        </div>
        <div class="col-2">
            <button class="btn-change"(click)="changeLocation()">Change</button>
        </div>
    </div>

    <div class="d-flex justify-content-center" style="padding: 15px 0px 5px 0px;">
        <button class="btn-confirm" [disabled]="disableConfirmButton" (click)="confirmLocation()">Confirm Location</button>
    </div>
</div>

<style>
/* ::ng-deep.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
    opacity: 0 !important;
} */

/* :host {
    opacity: 0 !important;
} */

::ng-deep .mat-bottom-sheet-container {
    padding: 8px 16px;
    min-width: 100vw;
    box-sizing: border-box;
    display: block;
    outline: 0;
    overflow: auto;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
}

::ng-deep.mat-bottom-sheet-container-large {
    min-width: 380px;
     max-width: 380px;
}

::ng-deep.mat-bottom-sheet-container-xlarge {
    min-width: 380px !important;
    /* max-width: calc(100vw - 384px); */
    max-width: 380px;
}
.btn-change {
    border: 0.75px solid #25CB7D;
    border-radius: 5px;
    color: #54AC58;
    background: #F4FFF4;
    font-size: 14px;
    line-height: 19px;
    font-weight: 450;
}
.btn-confirm {
    border: none;
    background: transparent linear-gradient(264deg, #56AB51 0%, #2FB9E3 100%) 0% 0% no-repeat padding-box;
    color: #ffffff;
    height: 40px;
    width: 295px;
    border-radius: 4px;
    font-size: 18px;
    line-height: 23px;
    letter-spacing: 0.9px;
    font-weight: 450;
}

button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
</style>
